import React from 'react';
import styled from 'styled-components';
import { media } from '../theme';
import { useConfig, vr } from '../utils';

const Login = () => (
  <div className="login">
    <form id="loginWrap" action="https://www.golfbox.dk/login.asp" className="login-form vertical" method="post" onSubmit="setTimeout('document.loginform.reset()', 200);" name="loginform" acceptCharset="UTF-8">
      <input id="loginform.submitted" name="loginform.submitted" type="hidden" value="true" />
      <input id="loginform-url" name="loginform-url" type="hidden" value="https://sollerodgolf.dk" />
      <input id="loginform-destination" name="loginform-destination" type="hidden" value="player" />
      <input id="loginform-club" name="loginform-club" type="hidden" value="{481E9DF4-09DA-4C91-B7D0-C3DFF9A0FE18}" />
      <input id="loginform-staff" name="loginform-staff" type="hidden" value="{481E9DF4-09DA-4C91-B7D0-C3DFF9A0FE18}" />
      <input id="loginform-lcid" name="loginform-lcid" type="hidden" value="1030" />
      <input id="command" name="command" type="hidden" value="website_login" />

      <label htmlFor="loginUsername">
        <span>Brugernavn</span>
        <input id="loginUsername" name="loginform.username" type="text" />
      </label>

      <label htmlFor="loginPassword">
        <span>Adgangskode</span>
        <input id="loginPassword" name="loginform.password" type="password" />
      </label>

      <input type="submit" name="submit" id="loginSubmit" className="btn green-fill full-size" onClick="window.golfbox_login.submit()" value="LOGIN" />

      <div style={{ marginTop: vr(0.5) }}>
        <small className="footer-links">
          <a href="https://www.golfbox.dk/portal/login/help.asp">Hjælp til login</a>
        </small>
        <small className="footer-links">
          <a href="https://www.golfbox.dk/portal/login/password.asp">Glemt password?</a>
        </small>
      </div>

    </form>
  </div>
);

const Tournaments = ({ id }) => {

  const { url } = useConfig();

  return (
    <iframe className="tournaments" src={`${url}/golfbox-iframe-turnering.html#/customer/330/schedule/${new Date().getFullYear()}/${id || 1030}`} title="Golfbox Turnering" />
  );
};

const Overview = () => {

  const { url } = useConfig();

  return (
    <iframe className="overview" src={`${url}/golfbox-iframe-oversigt.html`} title="Golfbox Oversigt" />
  );
};

export const IFrame = (props) => {

  const { url } = useConfig();

  return (
    <iframe src={`${url}/golfbox-iframe-custom.html?src=${props.url}`} style={{ height: props.height || 'auto' }} title="Indlejret side" />
  );
};

export const Golfbox = () => (
  <Container id="GolfboxModal">
    <Login />
    <Overview />
  </Container>
);

export const GolfboxTournaments = Tournaments;
export const GolfboxOverview = Overview;

const Container = styled.div`
  height: 100%;
  height: 80vh;
  max-width: 860px;
  width: 100%;
  flex-direction: column;
  align-items: center;

  .overview, .login {
    display: block;
  }

  .overview {
    height: 600px;
    width: 100%;
    max-width: 650px;
  }

  .login {
    overflow-y: hidden;
    padding-bottom: 20px;
    width: 80%;
    order: 0;
  }
  
  .footer-links {
    display: block;
  }
  
  #loginSubmit {
    margin-top: ${vr(0.5)};
  }
  
  form {
    width: auto;

    label {
      margin-bottom: ${vr(0.5)};
    }
  }
  
  @media ${media.tabletS} {
    display: flex;
    justify-content: center;
    flex-direction: row;
    height: 500px;
    flex-direction: row;
    align-items: flex-start;
    
    .login {
      width: 230px;
      padding-left: 20px;
      order: 1;
    }

    .overview {
      height: 100%;
      /* order: 1; */
    }
  }
`;
